import React from 'react'
import { connect } from 'react-redux'
import { doGetPersonAttachKindList } from '../../reducers/actions'
import PersonAttachKindDiv from './PersonAttachKindDiv'
class PersonAttachKindList extends React.Component {
    state = {}
    componentDidMount = () => {
        this.handleInitPersonAttachKind()
    }
    handleInitPersonAttachKind = () => {
        const { onSave, onClose, dispatch } = this.props
        dispatch(doGetPersonAttachKindList({
            onEnd: ({ errorMessage, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                }
                else if (initValues基本信息) {
                    this.setState({ initValues基本信息 })
                }
            }
        }))
    }

    handleAddPersonAttachKind = (data) => {
        Tyan.pubForm.showDialog('人员附件分类', props => <PersonAttachKindDiv {...props} id={-1} onSave={this.handleInitPersonAttachKind} />)
        this.setState({})
    }

    handleEditPersonAttachKind = (data) => {
        Tyan.pubForm.showDialog('人员附件分类', props => <PersonAttachKindDiv {...props} id={data.id} onSave={this.handleInitPersonAttachKind} />)
        this.setState({})
    }

    handlerClose = () => {
        const { onClose } = this.props
        onClose && onClose()
    }

    fieldset模板 = () => {
        return [{
            _grid: '', name: '人员附件分类', rowNumbers: true, minRows: 5,
            columns: [
                { _text: '分类名称', minWidth: 300, flex: 1 },
            ],
            onDoubleTap: this.handleEditPersonAttachKind,
        }]
    }

    render = () => {
        const { showBody: Body } = this.props

        return <Body data={this} maxWidth={1200}
            controls={
                [
                    { _button: '添加', handler: this.handleAddPersonAttachKind },
                    { _button: '关闭', handler: this.handlerClose },
                ]}
            fieldsets={[
                { title: '', name: '基本信息', _fieldset: this.fieldset模板(), /* docked: 'top',  */flex: 1 },
            ]}
        />
    }
}

export default connect()(PersonAttachKindList)